import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { WhySection } from './components/WhySection';
import { KitContentsSection } from './components/KitContentsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args);
        } else {
          n.queue.push(args);
        }
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
      (window as any).fbq('init', '837339689335252');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <main className="w-full min-h-screen bg-[#FDF8F3] overflow-x-hidden" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=837339689335252&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <WhySection data-id="element-6" />
      <KitContentsSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />

      <footer className="py-8 text-center text-[#3D3229]/40 text-sm bg-[#FDF8F3]" data-id="element-12">
        <p data-id="element-13">
          © {new Date().getFullYear()} Reset Emocional. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}